<template>
    <div class="img-roll-page">
        <div class="ad-img-list">
            <vue-seamless-scroll :data="adList" :class-option="classOption" class="table-content">
                <ul v-for="(item, index) in adList" :key="index" class="list">
                    <li class="li-item">
                        <img :src="item.icon" class="ad-img">
                        <div class="title">{{item.name}}</div>
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>
    </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
    name: "ImgRoll",
    components: {
        vueSeamlessScroll
    },
    props:{
        // 数据列表
        list:{
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            // 广告数据
            adList: [],
        }
    },
    computed: {
        // 对滚动组件的配置
        classOption(){
            return {
                singleHeight: 132,
                step: 0.4,
                waitTime: 3000,
                limitMoveNum: 2,
                direction: 1,
                // autoPlay: false,
            }
        }
    },
    watch: {
        'list': {
            immediate: true,
            handler(value){
                // console.log(value);
                this.adList = value;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.img-roll-page{
    display: flex;
    height:100%;
    width:100%;
    .ad-img-list{
        flex: 1;
        padding: 13px 0px;
        overflow: hidden;
        .table-content{
            width: 100%;
            height: 100%;
            overflow: hidden;
            .list{
                display: inline-block;
                width:25%;
                .li-item{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 15px;
                    .ad-img{
                        height: 22px;
                        width: auto;
                    }
                    .title{
                        margin-top: 10px;
                    }
                }
            }
        }
    }
}
</style>